export class MonthYear {
  public readonly year: number;
  /**
   * Month number in range 1-12 (matches `<input type="month">` value format).
   */
  public readonly month: number;

  constructor(year: number, month: number) {
    if (!Number.isInteger(year) || year < 0) {
      throw new Error(`Invalid year: ${year}`);
    }
    if (!Number.isInteger(month) || month < 1 || month > 12) {
      throw new Error(`Invalid month (expected 1-12): ${month}`);
    }
    this.year = year;
    this.month = month;
  }

  static fromDate(date: Date): MonthYear {
    return new MonthYear(date.getFullYear(), date.getMonth() + 1);
  }

  /**
   * Parses "YYYY-MM" (as produced by `<input type="month">`).
   */
  static fromString(value: string): MonthYear {
    const [y, m] = value.split("-");
    const year = Number(y);
    const month = Number(m);
    return new MonthYear(year, month);
  }

  toString(): string {
    return `${this.year}-${String(this.month).padStart(2, "0")}`;
  }

  toDisplayPtBR(): string {
    const months = [
      "Janeiro",
      "Fevereiro",
      "Março",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro",
    ];
    return `${months[this.month - 1]} de ${this.year}`;
  }

  addMonths(delta: number): MonthYear {
    const d = new Date(this.year, this.month - 1, 1);
    d.setMonth(d.getMonth() + delta);
    return MonthYear.fromDate(d);
  }
}
